import React, { useState } from 'react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [open, setOpen] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#082e2a] py-8 px-4 text-center" data-id="element-181">
        <p className="font-playfair text-[#c9a84c] font-semibold text-base mb-1" data-id="element-182">
          Reel-Mom Estratégica
        </p>
        <p className="font-dm text-white/40 text-sm mb-4" data-id="element-183">
          © 2025 Todos los derechos reservados
        </p>
        <div className="flex justify-center gap-6" data-id="element-184">
          <button onClick={() => setOpen('privacy')} className="font-dm text-white/40 hover:text-[#c9a84c] text-xs transition-colors underline underline-offset-2" data-id="element-185">
            Política de Privacidad
          </button>
          <span className="text-white/20" data-id="element-186">·</span>
          <button onClick={() => setOpen('terms')} className="font-dm text-white/40 hover:text-[#c9a84c] text-xs transition-colors underline underline-offset-2" data-id="element-187">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {/* Modal backdrop */}
      {open && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setOpen(null)} data-id="element-188">
          <div className="bg-[#fdf6ee] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-189">
            {/* Modal header */}
            <div className="sticky top-0 bg-[#0d4a45] px-6 py-4 rounded-t-2xl flex items-center justify-between" data-id="element-190">
              <h2 className="font-playfair text-white font-bold text-xl" data-id="element-191">
                {open === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setOpen(null)} className="text-white/60 hover:text-white text-2xl leading-none transition-colors w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10" aria-label="Cerrar" data-id="element-192">
                ×
              </button>
            </div>

            {/* Modal content */}
            <div className="px-6 py-6 space-y-5 font-dm text-[#3a3a3a] text-sm leading-relaxed" data-id="element-193">
              {open === 'privacy' ? <PrivacyContent data-id="element-194" /> : <TermsContent data-id="element-195" />}
            </div>

            {/* Modal footer */}
            <div className="px-6 pb-6 text-center" data-id="element-196">
              <button onClick={() => setOpen(null)} className="bg-[#0d4a45] hover:bg-[#1a6b64] text-white font-dm font-semibold text-sm px-8 py-3 rounded-full transition-colors" data-id="element-197">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-[#5a5a5a] text-xs" data-id="element-198">Última actualización: 2025</p>

      <div data-id="element-199">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-200">
          1. Información que recopilamos
        </h3>
        <p data-id="element-201">
          Al realizar una compra en nuestro sitio, recopilamos información
          necesaria para procesar tu pedido, incluyendo nombre y dirección de
          correo electrónico. No recopilamos información de pago directamente —
          esta es procesada de forma segura por nuestro proveedor de pagos.
        </p>
      </div>

      <div data-id="element-202">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-203">
          2. Uso de la información
        </h3>
        <p data-id="element-204">Utilizamos tu información únicamente para:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-205">
          <li data-id="element-206">Entregar el producto digital adquirido</li>
          <li data-id="element-207">Enviarte actualizaciones relacionadas con tu compra</li>
          <li data-id="element-208">Mejorar nuestros productos y servicios</li>
        </ul>
      </div>

      <div data-id="element-209">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-210">
          3. Compartir información
        </h3>
        <p data-id="element-211">
          No vendemos, alquilamos ni compartimos tu información personal con
          terceros, excepto cuando sea necesario para procesar tu pago o cumplir
          con obligaciones legales.
        </p>
      </div>

      <div data-id="element-212">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-213">
          4. Seguridad
        </h3>
        <p data-id="element-214">
          Implementamos medidas de seguridad razonables para proteger tu
          información. Sin embargo, ningún método de transmisión por Internet es
          100% seguro.
        </p>
      </div>

      <div data-id="element-215">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-216">
          5. Cookies
        </h3>
        <p data-id="element-217">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies,
          aunque esto puede afectar algunas funcionalidades del sitio.
        </p>
      </div>

      <div data-id="element-218">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-219">
          6. Tus derechos
        </h3>
        <p data-id="element-220">
          Tienes derecho a acceder, corregir o solicitar la eliminación de tu
          información personal en cualquier momento.
        </p>
      </div>

      <div data-id="element-221">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-222">
          7. Cambios a esta política
        </h3>
        <p data-id="element-223">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación en el sitio.
        </p>
      </div>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-[#5a5a5a] text-xs" data-id="element-224">Última actualización: 2025</p>

      <div data-id="element-225">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-226">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-227">
          Al adquirir Reel-Mom Estratégica, aceptas estos Términos y Condiciones
          en su totalidad. Si no estás de acuerdo con alguno de estos términos,
          no debes realizar la compra.
        </p>
      </div>

      <div data-id="element-228">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-229">
          2. Producto digital
        </h3>
        <p data-id="element-230">
          Reel-Mom Estratégica es un producto digital (guía en formato PDF y/o
          video). Una vez completada la compra, recibirás acceso inmediato por
          correo electrónico. Por la naturaleza del producto digital,{' '}
          <strong data-id="element-231">no se aceptan devoluciones</strong> una vez que el producto ha
          sido descargado o accedido.
        </p>
      </div>

      <div data-id="element-232">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-233">
          3. Uso permitido
        </h3>
        <p data-id="element-234">
          Este producto es para uso personal únicamente. Queda estrictamente
          prohibido:
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-235">
          <li data-id="element-236">Reproducir, distribuir o revender el contenido</li>
          <li data-id="element-237">Compartir el acceso con terceros</li>
          <li data-id="element-238">
            Utilizar el contenido con fines comerciales sin autorización escrita
          </li>
        </ul>
      </div>

      <div data-id="element-239">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-240">
          4. Descargo de responsabilidad
        </h3>
        <p data-id="element-241">
          Los resultados mencionados en este sitio son ejemplos de lo que es
          posible lograr. No garantizamos ingresos específicos. Tu éxito depende
          de tu dedicación, esfuerzo y circunstancias individuales. Este
          producto es educativo y no constituye asesoramiento financiero o
          legal.
        </p>
      </div>

      <div data-id="element-242">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-243">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-244">
          Todo el contenido de Reel-Mom Estratégica, incluyendo textos, imágenes
          y materiales, es propiedad exclusiva de sus creadores y está protegido
          por las leyes de derechos de autor aplicables.
        </p>
      </div>

      <div data-id="element-245">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-246">
          6. Modificaciones
        </h3>
        <p data-id="element-247">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. El uso continuado del producto después de los cambios implica
          la aceptación de los nuevos términos.
        </p>
      </div>

      <div data-id="element-248">
        <h3 className="font-playfair font-bold text-[#0d4a45] text-base mb-2" data-id="element-249">
          7. Ley aplicable
        </h3>
        <p data-id="element-250">
          Estos términos se rigen por las leyes aplicables en el Estado de
          Florida, Estados Unidos, sin perjuicio de sus disposiciones sobre
          conflictos de leyes.
        </p>
      </div>
    </>;
}